define('views/modules/setting/business/modals/payment-invoice-history-modal',[
    // Libs
    'underscore',
    'backbone',
    'jquery',
    'moment',
    'mustache',
    // services
    'services/i18n',
    'services/api',
    // views
    'views/parts/modal/modal',
    'views/modules/setting/business/list/invoice-history-list',
    // models
    'collections/payment/invoices',
    // templates
    'text!templates/modules/setting/business/modals/payment-invoice-history-modal.html',

], function(
    // Libs
    _, Backbone, $, moment, Mustache,
    // sessions
    i18n,
    API,
    // views
    VModal,
    VInvoiceHistoryList,
    // models
    CInvoices,
    //templates
    TPaymentInvoiceHistoryModal
) {
    var VPaymentInvoiceHistoryModal = VModal.extend({
        template: TPaymentInvoiceHistoryModal,
        regions: {
            invoiceList: "#invoice-list"
        },

        modal: function() {
            return {
                closeButton: true,
                title: i18n.t("payment:invoice_history_title"),
                size: 'large',
                buttons: {
                    loadMore: {
                        label: i18n.t("payment:invoice_history_load_more"),
                        className: 'btn-success invoice-history-load-more-button',
                        callback: function() {
                            this.collection.getNextPage();
                            return false;
                        }
                    },
                },
            };
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.collection = new CInvoices();

            var view = this.view = {
                invoiceList: new VInvoiceHistoryList({
                    collection: this.collection,
                })
            };

            this.listenTo(this.collection, { "sync": this.onCollectionChange });

            this.collection.fetch();
        },

        render: function() {
            this.refreshView();

            this.renderModal();

            return this;
        },

        refreshView: function() {
            var html = Mustache.render(this.template, Mustache.getContext({
                invoices: this.collection.toJSON(),
                hasInvoices: this.collection.length !== 0,
                apiURL: API.url("payments/archive")
            }));

            this.$el.empty().append(html);

            this.generateZones();

            this.assign(this.view.invoiceList, this.zone.$invoiceList);
        },

        show: function(model) {
            this.render();
        },

        onCollectionChange: function(e) {
            if (!this.collection.hasLeft()) {
                $('.invoice-history-load-more-button').prop("disabled", true);
            }

            this.refreshView();
        },


    });

    return VPaymentInvoiceHistoryModal;
});

